<div class="d-flex">
	<div class="input-group bg-transparent w-100 simple-searchbar">
		<input
			[(ngModel)]="searchValue"
			#instance="ngbTypeahead"
			#searchbarInput
			[focusFirst]="false"
			[showHint]="true"
			type="text"
			class="form-control cursor-pointer typeahead searchbar-placeholder"
			(selectItem)="selectItem($event)"
			name="searchbar"
			placeholder="{{ 'global.search' | translate }}"
			(click)="click.next($any($event).target.value)"
			placement="bottom-left bottom-right"
			[resultTemplate]="rt"
			[ngbTypeahead]="searchField" />
		<ng-template #rt let-r="result" let-i="index" class="test" let-t="term">
			<div [innerHTML]="r | searchhighlight: t"></div>
		</ng-template>
		<div class="position-absolute h-100 close-button">
			<div class="d-flex align-items-center h-100">
				@if (searchValue) {
					<img
						class="mask-settings cursor-pointer bg-gray-600 close-mask-img"
						(click)="clearImput()"
						style="height: 24px; width: 24px" />
				}
			</div>
		</div>
	</div>
</div>
